<div class="tal-home-container">
  <div class="tal-home-editor">
    <tal-code-editor #codeEditor></tal-code-editor>
  </div>
</div>
